/**
 * Get Balance Replacer View
 */

define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var BaseReplacerView = require('common/base.replacer.view');
    var user = require('user');

    module.exports = BaseReplacerView.extend({

        tagName: 'span',

        className: 'val_type_user_balance',

        accessRules: {
            allow: ['user']
        },

        initialize: function(options) {
            this.options = _.extend({
                balanceType: options.params[0]
            }, options);
        },

        subscribe: function() {
            this.listenTo(user, 'change:balance', this.render.bind(this));
        },

        render: function() {
            var balances = user.get('balance')?.balances || {};
            var balance = balances[this.options.balanceType];
            var formattedBalance, amount, currencyCode;

            if (balance) {
                amount = balance.amount;
                currencyCode = balance.currencyCode;

                // currencyCode received from IMS, if it's only number currencyCode = 'XXX'
                if (balance.currencyCode !== 'XXX') {
                    formattedBalance = window.Playtech.API.formatter.formatCurrency(amount, {currencyCode: currencyCode});
                } else {
                    formattedBalance = amount;
                }

                this.$el.html(formattedBalance);
            }

            return this;
        }
    }, {
        nameOfReplacers: [
            'GET_BALANCE'
        ]
    });
});
